import { render, staticRenderFns } from "./InquiriesView.vue?vue&type=template&id=1ec90c60&scoped=true&"
import script from "./InquiriesView.vue?vue&type=script&lang=js&"
export * from "./InquiriesView.vue?vue&type=script&lang=js&"
import style0 from "./InquiriesView.vue?vue&type=style&index=0&id=1ec90c60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec90c60",
  null
  
)

export default component.exports